
      const measurementId = import.meta.env.VITE_PUBLIC_GA_MEASUREMENT_ID;
      window.__safaqatLoadGA = function () {
        if (!measurementId || window.__safaqatGALoaded) return;
        window.__safaqatGALoaded = true;
        const gaScript = document.createElement('script');
        gaScript.async = true;
        gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
        document.head.appendChild(gaScript);
        window.dataLayer = window.dataLayer || [];
        window.gtag = function gtag() { window.dataLayer.push(arguments); };
        window.gtag('js', new Date());
        window.gtag('config', measurementId);
      };
      try {
        const raw = localStorage.getItem('safaqat24.cookieConsent');
        if (raw && JSON.parse(raw).analytics === true) window.__safaqatLoadGA();
      } catch (e) {
        /* localStorage blocked — GA stays off until consent */
      }
    